import { logUtil } from 'packages/src'

/**
 * @param props
 * @param props.user
 * @param props.trainingUser
 * @param props.email
 * @param props.route
 * @param props.isInLinks
 */
const shouldShowNewsletterSelectUtil = ({
  user,
  trainingUser,
  email,
  route,
  isInLinks
}) => {
  const res = (
    !user &&
    !trainingUser &&
    !email &&
    !route?.isApp &&
    !isInLinks
  )

  const debugProps = {
    res
  }
  logUtil('initModalNewsletterAction').debug('debugProps=', debugProps)
  return res
}

export default shouldShowNewsletterSelectUtil
